<template>
  <div class="MESSAGE">
    <!-- TODO - coresecurity token api does not return image, so find the correct api -->
    <avatar
        v-if="isHuman"
        :name="message.sender_full_name"
        :id="message.sender"
        :image="isSenderConsumer && profileImage ? profileImage : ''"
        class="flex-0-0"
        selenium="message-avatar"/>
    <vk-icon v-else :name="getIconNameForType(message.type)" class="h3 c-gray70"/>
    <div class="flex-1-1 x-min-width-0 x-word-wrap-break-word m-x-1 m-x-2:t">
      <div v-if="isHuman" class="text-bold text-uppercase" selenium="sender-full-name-label">
        {{ message.sender_full_name }}
      </div>
      <div selenium="message-content-label">{{ message.message }}</div>
      <gallery v-if="hasImages" :files="messageFiles"/>
    </div>
    <div class="flex-0-0 c-gray50" selenium="message-received-time-stamp-label">
      {{ message.time_created | timeOfDay }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

// TODO: Complete missing status codes
const systemMessageTypes = {
  S_CV: 'phone-call', // Pro called customer
  S_JR: 'lightning', // New job request received
  S_CC: '',
  S_OP: 'filled-check', // Pro completed this job
  S_CP: '',
};

export default {
  name: 'message',
  components: {},
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['profileImage', 'userId']),
    ...mapGetters('consumer/files', ['files']),
    isHuman () {
      return this.message.message_type !== 'system';
    },
    isSenderConsumer () {
      return this.message.sender_id === this.userId;
    },
    hasImages () {
      return this.message.asset_urls && this.message.asset_urls.length;
    },
    messageFiles () {
      return this.message.asset_urls.map(url => ({ url }));
    },
  },
  methods: {
    getIconNameForType (type) {
      return systemMessageTypes[type];
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .MESSAGE {
    @include padding(1 1 2 0, 2 0 3 0);
    display: flex;

    &:last-of-type {
      @include padding-bottom(0);
    }

    &.SYSTEM-MESSAGE {
      @include padding(1, 2);
      @include margin-y(1);
      display: flex;
      align-items: center;
      background-color: $color-gray20;
      border: 1px solid $color-gray40;
    }
  }
</style>
